
<template>
  <v-layout wrap pb-12>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-snackbar v-model="showsnackbar" color="#9eaade" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-flex xs12 pb-3>
      <span style="font-family: nunitosansbold; font-size: 18px">
        Create new Notice</span
      >
    </v-flex>
    <v-flex>
      <v-card>
        <v-form ref="form" @submit.prevent="validateInput">
          <v-layout wrap>
            <v-flex py-8 pa-3> Title </v-flex>
            <v-flex pa-3 xs12>
              <v-text-field
                :rules="[rules.required]"
                style="font-family: nunitosansextrabold; font-size: 30px"
                v-model="title"
                outlined
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 pa-3> Upload an image </v-flex>
            <v-flex xs12 pt-5 px-3>
              <CoverImageComp
                @stepper="winStepper"
                :height="'5118'"
                :width="'8001'"
                :heading="'Upload Cover Image'"
                :componentType="'coverImage'"
              />
            </v-flex>
            <v-flex xs12 pa-3>
              <v-layout wrap>
                <v-flex md3>
                  <!-- <v-file-input
                    hide-details
                  outlined
                  dense
                  show-size
                  label="File input"
                    @change="browseImages"
                  /> -->
                </v-flex>
                <v-flex md5 pl-3>
                  <div v-if="image" width="80px" height="80px">
                    <v-img width="80px" height="80px" :src="image" />
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 pa-3> Upload document </v-flex>
            <v-flex xs12 pa-3>
              <v-layout wrap>
                <v-flex md12>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-file-input
                        hide-details
                        outlined
                        dense
                        show-size
                        multiple
                        label="File input"
                        @change="browseDocs"
                      />
                    </v-flex>
                    <v-flex md12 pt-3 pl-md-6>
                      <v-btn
                        style="margin-left: 1%"
                        v-for="(item, i) in docs"
                        :key="i"
                        @click="unselect(i)"
                      >
                        {{ item.name }} <span><v-icon>mdi-close</v-icon></span>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <!-- :multiple="false" -->
                  <!-- <input
            ref="files"
            type="file"
           
           multiple
            id="fileUpload"
           
            @change="browseDocs"
          /> -->
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 py-5 pa-3> Text </v-flex>
            <v-flex xs12 pa-3>
              <v-textarea
                :rules="[rules.required]"
                flat
                v-model="description"
                height="400px"
                outlined
              >
              </v-textarea>
            </v-flex>
            <v-flex pa-3 xs12 md4>
              <v-text-field
                :rules="[rules.required]"
                dense
                flat
                readonly
                label="Author"
                style="font-family: nunitosansextrabold"
                v-model="Data.name"
                outlined
              >
              </v-text-field>
            </v-flex>
            <v-flex pa-3 xs12 md4>
              <v-text-field
                :rules="[rules.required]"
                dense
                flat
                label="Designation"
                style="font-family: nunitosansextrabold"
                v-model="designation"
                outlined
              >
              </v-text-field>
            </v-flex>
            <v-flex xs4 sm11 md4 text-center py-3 pl-3 pl-md-0>
              <v-btn
                color="#9385EF"
                elevation="0"
                dark
                @click="submit"
                max-width="100"
              >
                submit
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import CoverImageComp from "./singleImage";
import store from "../../store";
export default {
  components: {
    CoverImageComp,
  },
  data() {
    return {
      //  selectedFiles: [],
      // image: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      docs: [],
      showsnackbar: false,
      msg: "",
      timeout: 5000,
      appLoading: false,
      title: "",
      description: "",
      selectedFiles: "",
      image: null,
      author: "",
      designation: "",
      id: "",
      imgdata: new FormData(),
      docsdata: new FormData(),
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    Data() {
      return store.state.completeUserData;
    },
  },
  methods: {
    // validateInput() {
    //   if (!this.coverImageFile) {
    //     this.msg = "Please Upload Photo";
    //     this.showsnackbar = true;
    //     return;
    //   } else {
    //     this.submit();
    //   }
    // },
    unselect(value) {
      this.docs.splice(value, 1);
    },
    winStepper(window_data) {
      if (window_data.type == "coverImage") {
        this.coverImageFile = window_data.selectedFiles;
      }
    },
    go() {
      this.$router.push({ path: "/noticeboard2" });
    },
    browseImages(file) {
      this.selectedFiles = file;
      this.image = URL.createObjectURL(this.selectedFiles);
      console.log("image is", this.selectedFiles);
      console.log("image url", this.image);
    },
    browseDocs(file) {
      // for(let i=0 ; i<event.target.files.length; i++)
      // this.docs.push(event.target.files[i]) ;
      for (let i = 0; i < file.length; i++) {
        this.docs.push(file[i]);
      }

      // console.log("docs is=",this.docs)
    },
    submit() {
      if (this.$refs.form.validate() && this.coverImageFile != null) {
        this.appLoading = true;
        axios({
          method: "post",
          url: "/notice/add",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: {
            title: this.title,
            description: this.description,
            author: this.author,
            designation: this.designation,
          },
        }).then((response) => {
          if (response.data.status) {
            this.id = response.data.id;
            this.imgdata.append("id", this.id);
            this.imgdata.append("photo", this.coverImageFile);

            if (this.id) {
              this.uploadDocs();
            }
          } else {
            alert("failed to add the text values");
          }
        });
      } else {
        this.showsnackbar = true;
        this.msg = "please Select an image";
      }
    },
    uploadDocs() {
      this.docsdata.append("id", this.id);
      if (this.docs.length > 0) {
        for (var i = 0; i < this.docs.length; i++) {
          this.docsdata.append("docs", this.docs[i]);
        }
      }
      // this.docsdata.append("docs", this.docs);
      axios({
        method: "post",
        url: "/notice/uploaddocs",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.docsdata,
      }).then((response) => {
        axios({
          method: "post",
          url: "/notice/uploadimage",
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
          data: this.imgdata,
        }).then((response) => {
          if (response.data.status) {
            this.showsnackbar = true;
            this.msg = "Successfully added";
            this.appLoading = false;
            this.go();
          } else {
            this.showsnackbar = true;
            this.msg = "failed to add Notice";
          }
        });
        if (response.data.status) {
          console.log("success");
        } else {
          console.log("failed");
        }
      });
    },
  },
};
</script>